import React, { useEffect, useState } from 'react'
import { Box, Typography, Paper, List, ListItem, ListItemText } from '@mui/material'
import { getUserEnrollments } from '../api/assignments'
import logger from '../utils/logger'

const DebugAssignments: React.FC = () => {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        logger.debug('Fetching user enrollments...')
        const response = await getUserEnrollments()
        logger.debug('Response:', response)
        setData(response.data)
      } catch (err: any) {
        logger.error('Error:', err)
        setError(err.message || 'Unknown error')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Debug Assignments
      </Typography>
      
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Status:</Typography>
        <Typography>Loading: {loading ? 'Yes' : 'No'}</Typography>
        <Typography>Error: {error || 'None'}</Typography>
        <Typography>Data Count: {data ? (Array.isArray(data) ? data.length : 1) : 0}</Typography>
      </Paper>

      {data && (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Raw Data:
          </Typography>
          <pre style={{ fontSize: '12px', overflow: 'auto' }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </Paper>
      )}

      {Array.isArray(data) && (
        <Paper sx={{ p: 2, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            User Enrollments:
          </Typography>
          <List>
            {data.map((enrollment: any, index: number) => (
              <ListItem key={index}>
                <ListItemText
                  primary={enrollment.content_name || enrollment.assignment?.title}
                  secondary={`Status: ${enrollment.status} | Type: ${enrollment.content_type}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  )
}

export default DebugAssignments
